import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FolderOpenOutlined } from "@ant-design/icons";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Table,
  Tooltip,
  Button,
  Form,
  Spin,
  Row,
  Col,
  Input,
  Modal,
  Divider,
  Select,
  DatePicker,
  InputNumber,
} from "antd";
import { EditOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../../security.config";
import styles from "../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const Token = (props) => {
  const navigate = useNavigate();
  const { configList, userData, refreshList, useForm } = props;

  const columns = [
    {
      title: labelConfig.name,
      dataIndex: "name",
      sorter: (a, b) => a["name"].localeCompare(b["name"]),
    },
    {
      title: labelConfig.value,
      dataIndex: "value",
    },
  ];

  return (
    <>
      <Row>
        {BOM.HasPermission("UPDATE_TWOFACTOR_CONFIGURATION") && (
          <EditToken
            userData={userData}
            refreshList={refreshList}
            useForm={useForm}
          />
        )}
      </Row>
      <Divider orientation="left" />

      <Table columns={columns} dataSource={configList} />
    </>
  );
};

export default Token;

const EditToken = (props) => {
  const { currentCustomerObj, userData, limitObj, refreshList, useForm } =
    props;
  const { session } = userData;
  const { TextArea } = Input;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmitLimit = (formValues) => {
    const url = `${apiConfig.TwoFactor}/configure`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateTokenMsg);

        // close modal
        setIsModalOpen(false);

        //refresh the list
        refreshList();

        //STOP LOAD
        setIsLoading(false);
      }
    },{
                navigate,
                showCheckerModal: showCheckerApprovalModal,
                onCheckerApproval: (res) => {
                  // navigate("/sms0100");
                  refreshList();
                  setIsLoading(false);
                },
              });
  };

  return (
    <>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
      >
        <EditOutlined />
        &nbsp;{labelConfig.edit}
      </Button>
      <Modal
        title="Edit Email"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmitLimit}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left">{labelConfig.generalInfo}</Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.otpTokenLength}
                name={labelConfig.otpTokenLength}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.otpTokenLength
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.accessTokenLiveTimeExtended}
                name={labelConfig.accessTokenLiveTimeExtended}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.accessTokenLiveTimeExtended
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.otpTokenLiveTime}
                name={labelConfig.otpTokenLiveTime}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.otpTokenLiveTime
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.accessTokenLiveTime}
                name={labelConfig.accessTokenLiveTime}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.accessTokenLiveTime
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
